// firebase 11 via de compat-laag: dezelfde namespaced API als firebase 8
// (`firebase.firestore.FieldValue`, `firebase.app().functions(...)`), zodat de
// rest van de app niet hoeft te veranderen. De onderdelen worden geregistreerd
// in ./compat. De modular API (`firebase/auth`, nodig voor MFA met een
// authenticator-app) praat met dezelfde app; zie modularAuth.js.
// AI-CONTEXT: See docs/features/mfa-totp.md
import firebase from './compat'

const config = {
  apiKey: "AIzaSyDfHDAPUhBE-t8k41EHbOVpsy2q0kzKe_o",
  authDomain: "deccos-app.firebaseapp.com",
  projectId: "deccos-app",
  storageBucket: "deccos-app.appspot.com",
  messagingSenderId: "53449363588",
  appId: "1:53449363588:web:6213c4bfb2623bd944b2d1"
};

firebase.initializeApp(config)

const auth = firebase.auth()
const db = firebase.firestore();

// Laat de SDK zelf ontdekken dat hij moet terugvallen op long-polling.
//
// WAAROM. Inloggen en gegevens ophalen lopen over twee verschillende
// verbindingen: inloggen is een gewone HTTPS-aanvraag en komt overal doorheen,
// maar Firestore gebruikt standaard een openstaande streamverbinding
// (WebChannel). Bedrijfsproxy's, virusscanners die HTTPS openbreken en sommige
// privacy-extensies bufferen die verbinding eindeloos, waardoor hij nooit
// antwoordt. Het beeld bij de gebruiker: inloggen lukt, en daarna komt er geen
// enkel gegeven binnen -- blijvend, en alleen bij hem.
//
// In firebase 8 stond deze stand UIT; sinds versie 10 is hij de norm. We zetten
// hem toch expliciet: zonder hem is er geen plan B en staat zo iemand er voor
// altijd buiten, en een standaard kan bij een volgende upgrade weer wisselen. 'AutoDetect'
// en niet 'Force': de terugval kost snelheid en wordt alleen gebruikt waar hij
// nodig is. De twee standen sluiten elkaar uit -- samen gooit de SDK.
//
// Moet vóór elke andere Firestore-aanroep staan, anders weigert settings().
// `merge: true`: zonder merge vervangt settings() in firebase 10+ álle
// instellingen, en waarschuwt de SDK dat we de host overschrijven.
db.settings({ experimentalAutoDetectLongPolling: true, merge: true });
const bucket = firebase.storage();
const timestamp = firebase.firestore.Timestamp.fromDate(new Date())

// AI-CONTEXT: See docs/pitfalls.md#dev-firebase-useemulator-traps-prod-calls
// Do NOT add `useEmulator` calls for `europe-west1` here — they will silently
// route every Cloud Function call to localhost:5001. If you need emulator
// routing for the main backend region, gate it behind an explicit env flag
// (REACT_APP_USE_EMULATORS) so it's opt-in instead of opt-out.
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  firebase.functions().useEmulator("localhost", 5001);
}

export { auth, db, bucket, timestamp }